import React from "react";
import { product } from "../data/product";
import { Bonuses } from "../components/Bonuses";
import { BundleOffer } from "../components/BundleOffer";
import { Collections } from "../components/Collections";
import { Comparison } from "../components/Comparison";
import { FaqSection } from "../components/FaqSection";
import { Footer } from "../components/Footer";
import { Header } from "../components/Header";
import { Hero } from "../components/Hero";
import { InsideRecipe } from "../components/InsideRecipe";
import { Marquee } from "../components/Marquee";
import { Reviews } from "../components/Reviews";
import { Steps } from "../components/Steps";
import { Accent } from "../components/ui/SectionHeading";
export function Landing() {
  return <div lang="it" className="min-h-screen w-full bg-cream font-sans text-ink [hyphens:manual]" data-id="element-194" data-mp="cbibxrhoo8jd">
      <Header data-id="element-195" data-mp="h6e730i7vc0p" />
      <main data-id="element-196" data-mp="m7le2xcjc76b">
        <Marquee data-id="element-197" data-mp="m7bxu1haledt" />
        <Hero data-id="element-198" data-mp="m6shuqb7d02f" />
        <Comparison data-id="element-199" data-mp="m8da29a1o6x4" />
        <Reviews data-id="element-200" data-mp="m7v4gm1hsgcj" />
        <BundleOffer id="acquista" withGallery title={<>
              Tutto ciò che ti serve, <Accent data-id="element-202" data-mp="3tftm2yijcumz">in un unico bundle</Accent>
            </>} subtitle="Dai burri corpo agli scrub, dagli oli ai sieri: tutto spiegato in modo semplice, per iniziare oggi stesso." data-id="element-201" data-mp="m58xoomfe4vd" />
        <InsideRecipe data-id="element-203" data-mp="3kgf0acdbd88t" />
        <Collections data-id="element-204" data-mp="3kh7wijencfcp" />
        <Bonuses data-id="element-205" data-mp="3khq3a9yxqbyv" />
        <Steps data-id="element-206" data-mp="l0i9m2h3z1oe" />
        <FaqSection data-id="element-207" data-mp="l11iktos6fqa" />
        <BundleOffer id="bundle" title={<>
              Da chi compra <Accent data-id="element-209" data-mp="gzzfu2vnnljk">a chi crea</Accent>
            </>} subtitle={`${product.recipesTextCap} ricette in ${product.volumesCount} volumi che trasformano la tua cucina nell'unico scaffale di bellezza di cui hai bisogno.`} data-id="element-208" data-mp="kzgo142guwsf" />
      </main>
      <Footer data-id="element-210" data-mp="14oio4iepfybn" />
    </div>;
}